import { CardBody } from '@euler/app/flows/bi-dashboards/dashboard/card/CardBody';
import { biCardKind } from '@euler/app/flows/bi-dashboards/functions/biCardKind';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiPalette } from '@euler/model/bi/viz';
import { memo } from 'react';
import { View } from 'react-native';
import { BiGalleryDashboardCard } from '../../functions/biGalleryTypes';

const noop = () => undefined;

/** A small live drawing of a category's card; it takes no touches. */
export const TilePreview = memo(
  ({ card, palette }: { card: BiGalleryDashboardCard; palette: BiPalette }) => {
    const { rpx } = useResponsiveContext();
    return (
      <View
        pointerEvents="none"
        style={{ height: rpx(176), overflow: 'hidden' }}
      >
        <CardBody
          state={card.data}
          viz={card.viz}
          kind={biCardKind(card.viz)}
          compact
          palette={palette}
          chartHeight={rpx(110)}
          scroll={false}
          onRetry={noop}
        />
      </View>
    );
  },
);
